// extracted by mini-css-extract-plugin
export default {"root":"IconQuestionMark_root__y9yMd"};